import {Box, Container, Flex, Text, VStack} from '@chakra-ui/react'
import PostThumbnail from './components/PostThumbnail'
import Page from '../../_app/components/Page/Page'
import React, {useEffect, useState} from 'react'
import {useTranslation} from 'next-i18next'
import Image from 'next/legacy/image'
import ImageHelper from '../../helpers/ImageHelper/ImageHelper'
import HomepageProducts from '../home/HomepageProducts'
import SeoHelper from '../../helpers/SeoHelper/SeoHelper'
import FixMagentoHelper from '../../helpers/FixMagentoHelper/FixMagentoHelper'
import Contents from '../../components/atoms/Contents/Contents'
import BreakpointsHelper from '../../helpers/BreakpointsHelper/BreakpointsHelper'

const PostMagento = ({post, relatedPostsNew}) => {
    const [sections] = useState(post?.sections)
    const {t} = useTranslation('blog')
    const style = {
        title: {
            marginBottom: '24px',
            marginTop: '24px',
        },
        topics: {
            alignItems: 'center',
            marginRight: '15px',
            padding: '10px 10px 10px 0',
        },
        topic: {
            background: '#f3f3f3',
            padding: '10px 20px',
            marginRight: '15px',
            textTransform: 'uppercase',
            fontWeight: '300',
            fontSize: '14px',
            borderRadius: '3px',
        }
    }
    const [isImageValid, setIsImageValid] = useState(false)
    useEffect(() => {
        ImageHelper.checkImage(post?.cover_image, (isValid: boolean | ((prevState: boolean) => boolean)) => {
            setIsImageValid(isValid)
        })
    }, [post?.cover_image])
    const [section, setSection]: any = useState([])
    useEffect(() => {
        const products = post?.products
        if (products?.length > 0) {
            const tempSection: any = {
                items: []
            }
            products?.forEach(el => {
                tempSection.items.push({
                    id: el?.entity_id,
                    url_key: el?.url_key,
                })
            })
            tempSection.title = t('PRODUCTS_RELATED')
            tempSection.rows = 1
            setSection(tempSection)
        }
    }, [post?.products])
    useEffect(() => {
        FixMagentoHelper.bannersBackground()
    }, [])
    return (
        <Page
            seo={{
                title: SeoHelper.getTitle(post?.title),
                description: SeoHelper.getDescription(post?.description),
            }}
        >
            <Container overflow="hidden">
                <Flex
                    justifyContent="space-between"
                    mt={{
                        base: '16px',
                        lg: '48px',
                    }}
                    mb="48px"
                    flexDir={{
                        base: 'column',
                        lg: 'row',
                    }}
                    gap="48px"
                >
                    <Box
                        sx={{
                            width: '100%',
                        }}
                        maxW={{
                            base: 'unset',
                            lg: '1440px',
                        }}
                    >
                        <Image
                            src={isImageValid ? post?.cover_image : '/images/blog.jpg'}
                            height={BreakpointsHelper.isMobile() ? 320 : 560}
                            width={920}
                            style={{
                                width: '100%',
                                objectFit: 'cover',
                            }}
                            alt="blog image"
                        />
                        <Box position="relative">
                            {
                                post?.category && (
                                    <Box
                                        position="absolute"
                                        left="12px"
                                        bottom="14px"
                                        bg="veryLightPink"
                                        padding="6px 12px"
                                    >
                                        <Text textTransform="uppercase" fontSize="12px">
                                            {post.category}
                                        </Text>
                                    </Box>
                                )
                            }
                        </Box>
                        <Contents sections={post?.sections}/>
                        <Box sx={{marginTop: '24px', marginBottom: '24px', fontWeight: '300'}}>
                            {`${post?.author || ''}, ${post?.date || ''}`}
                        </Box>
                        {
                            post?.topics?.length > 0 && (
                                <Box sx={{display: 'flex'}}>
                                    <Box sx={style.topics}>
                                        {t('TOPICS')}:
                                    </Box>
                                    {
                                        post?.topics?.map((el: string | number | bigint | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactPortal | Promise<React.AwaitedReactNode> | Iterable<React.ReactNode> | null | undefined, index: React.Key | null | undefined) => {
                                            return (
                                                <Box key={index} sx={style.topic}>{el}</Box>
                                            )
                                        })
                                    }
                                </Box>
                            )
                        }
                        <Text sx={style.title} as="h1" textStyle="sectionHeader">
                            {post?.title?.charAt(0).toUpperCase() + post?.title?.slice(1)}
                        </Text>
                        <Box className="postContent" dangerouslySetInnerHTML={{__html: sections}}/>
                    </Box>
                    <Box w="100%" maxW={BreakpointsHelper.isMobile() ? 'none' : '330px'}>
                        {relatedPostsNew?.length > 0 && (
                            <>
                                <Text textStyle="h4" mb="24px">
                                    {t('OTHER_ARTICLES')}
                                </Text>
                                <VStack spacing={6}>
                                    {relatedPostsNew?.map(post => (
                                        <PostThumbnail
                                            key={post?.id}
                                            post={post}
                                            category={post?.categories?.items?.[0]?.name}
                                        />
                                    ))}
                                </VStack>
                            </>
                        )}
                    </Box>
                </Flex>
                <HomepageProducts
                    title={section.title}
                    items={section.items}
                    rows={section.rows}
                />
            </Container>
        </Page>
    )
}

export default PostMagento